import BaseStrategy from './BaseStrategy';

const Reconnect = () => <BaseStrategy authStep="reconnect" />;

export default Reconnect;
